import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LoadingOverlay } from '../components/shared/ui/Loading';
import { handleOAuthCallback } from '../utils/auth';

function LoginCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fail = (reason: 'account' | 'session' | 'failed') =>
      navigate(`/login?login_error=${reason}`, { replace: true });

    const code = searchParams.get('code');

    if (searchParams.get('error')) {
      // The pre sign-up trigger denies users who have no account, and Cognito
      // reports that rejection here. Other federation errors are transient or
      // configuration faults, so they get the retry message instead.
      const description = searchParams.get('error_description') ?? '';
      fail(description.includes('PreSignUp') ? 'account' : 'failed');
      return;
    }

    if (!code) {
      fail('failed');
      return;
    }

    handleOAuthCallback(code, searchParams.get('state'))
      .then(() => navigate('/', { replace: true }))
      .catch((err: unknown) =>
        // auth.ts raises AuthFlowError when the callback state or the PKCE
        // verifier fails to check out. Keying on `name` matches how that
        // module's own error tables identify SDK exceptions.
        fail(
          err instanceof Error && err.name === 'AuthFlowError'
            ? 'session'
            : 'failed',
        ),
      );
  }, [navigate, searchParams]);

  return <LoadingOverlay open message="Signing you in…" />;
}

export default LoginCallback;
